module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-310x310-7991507ea6ffe5cc54cdcac2339ac6ed.png";